module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-04-7d3c4d98b036d75b2eb42251a4f50ec9.svg";